import { VisitTemplate } from '@dreryk/egabinet-visit-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { VisitTemplateInsert } from '../VisitTemplates.types';

import { VisitTemplatesModal } from './VisitTemplatesModal';

type MagistralDrugTemplateModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type VisitTemplatesModalOpenerProps = {
   readonly children: (renderProps: MagistralDrugTemplateModalOpenerChildrenRenderProps) => JSX.Element;
   readonly defaultTemplate: Omit<VisitTemplate, 'id'> | (() => Omit<VisitTemplate, 'id'>) | undefined;
   readonly onInsert: VisitTemplateInsert;
};

export const VisitTemplatesModalOpener = (props: VisitTemplatesModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <VisitTemplatesModal
               onClose={closeModal}
               initialEditItem={props.defaultTemplate}
               onInsert={props.onInsert}
            />
         ) : null}
      </>
   );
};
